// @flow
import type { IntegrationsState } from "@modules/integrations/types";

export const closedModal = { visible: false, application: null };

export const initialState: IntegrationsState = {
  list: [],
  isLoading: false,
  details: null,
  secretKey: null,
  offlineToken: null,
  applicationFormModal: { ...closedModal },
  deleteModal: { ...closedModal },
  tokenModal: { ...closedModal },
};

export default initialState;
